import { COLORS } from 'helpers/globals'

export default {
  container: {
    fontSize: '1.5rem'
  },
  fixed: {
    fontWeight: '200',
    color: COLORS.secondary,
    fontSize: '1.2rem',
    marginLeft: '1rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/FocalLengthContainer/ModelFocalLengthDisplay/style.js